import src from "IMAGE";
export default { src, width: 307, height: 337, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAQklEQVR42p2K0QoAEBAE/f/fCiHc2bqjO4+2prZmAusmaMScQVxCOBKfO0QBaQlODpKgKleSBpMkGlaewOLku3+5AbQa3oUJvPwQAAAAAElFTkSuQmCC"};
